// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__hgyA7","head":"styles_head__es7lL","buttonGroup":"styles_buttonGroup__OwNAT","button":"styles_button__V94Tj","buttonTabs":"styles_buttonTabs__6yLWT"};